export default function consentmanagerTrigger() {
    const cmpButton = document.querySelector('.stoof-show-cmp-overlay');

    if (cmpButton) {
        cmpButton.addEventListener('click', (ev) => {
            if(ev.target.getAttribute('href') !== '#!') return;
            ev.preventDefault();

            if (typeof __cmp === "function") {
                __cmp('showScreenAdvanced')
            }
        })
    }
}